import React from 'react'
import injectSheet from 'react-jss'
import Arrow from '../../icons/arrowIcon'

class SelectInput extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      open: false,
    }

    this.getTopSelection = this.getTopSelection.bind(this)
    this.toggleOpen = this.toggleOpen.bind(this)
  }

  getTopSelection() {
    const {
      options = [],
      placeholder,
      selection = [],
    } = this.props

    if (selection.length > 0) {
      const option = options.find(op => op.id === selection[0])
      if (option !== undefined) {
        return ((selection.length === 1) ? option.title : `(${selection.length} Elemente)`)
      }
    }
    return placeholder
  }

  toggleOpen() {
    this.setState({
      open: !this.state.open,
    })
  }

  render() {
    const {
      classes,
      field,
      options,
      selection,
      handleSelect,
    } = this.props

    const {
      open,
    } = this.state

    return (
      <div
        className={`${classes.selectContainer} ${open && 'open'} ${(selection.length < 1) && 'noSelection'} selectInput`}
        role="button"
        tabIndex={0}
        onClick={this.toggleOpen}
        onKeyDown={() => false}
      >
        <div className={`${classes.selectionContainer}`}>
          {this.getTopSelection()}
        </div>
        <div className={`${classes.arrowContainer}`}>
          <Arrow />
        </div>
        <ul className={`${classes.optionsContainer}`}>
          {options && Array.isArray(options) && options.map(option => (
            <li
              key={`option-${option.id}`}
              className={`${classes.option} ${selection.includes(option.id) && 'selected'}`}
            >
              <div
                className={`${classes.optionButton}`}
                role="button"
                tabIndex={0}
                onClick={(event) => {
                  event.stopPropagation()
                  handleSelect(field, option.id)
                }}
                onKeyDown={() => false}
              >
                {option.title}
              </div>
            </li>
          ))}
        </ul>
      </div>
    )
  }
}

const styles = theme => ({
  selectContainer: {
    position: 'relative',
    display: 'flex',
    flexWrap: 'nowrap',
    width: '100%',
    padding: `${theme.sizes.gutter / 2}px`,
    cursor: 'pointer',
    '&.noSelection': {
      color: theme.colors.secondary_3a,
    },
    '&.open $arrowContainer': {
      transform: 'rotate(90deg)',
    },
    '&.open $optionsContainer': {
      display: 'block',
      opacity: 1,
    },
  },
  selectionContainer: {
    width: '100%',
    height: '20px',
  },
  arrowContainer: {
    width: '20px',
    height: '20px',
    transform: 'rotate(0)',
    transition: [
      {
        property: 'transform',
        duration: theme.speed.fast,
      },
    ],
  },
  optionsContainer: {
    display: 'none',
    position: 'absolute',
    bottom: 0,
    left: 0,
    transform: 'translateY(100%)',
    margin: 0,
    padding: 0,
    backgroundColor: theme.colors.main_2,
    width: '100%',
    listStyleType: 'none',
    border: `1px solid ${theme.colors.secondary_3a}`,
    borderRadius: '3px',
    maxHeight: '100px',
    overflowY: 'scroll',
    zIndex: 99,
    color: theme.colors.secondary_3b,
  },
  option: {
    padding: `2px ${theme.sizes.gutter / 2}px`,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.colors.secondary_3a,
    },
    '&.selected': {
      backgroundColor: theme.colors.main_1,
      color: theme.colors.main_2,
    },
  },
  optionButton: {

  },
})

export default injectSheet(styles)(SelectInput)



// WEBPACK FOOTER //
// ./src/modules/core/components/selectInput.jsx